import {APP} from "../Utils/Constants.ts";

type TypeFormationMap = {
  [key:string]:number;
}


const sanitizeSolrInput = (query: any) => {
  const value = Array.isArray(query) ?query[0] : query;
  let parts = value.trim().split(' ');
  parts = parts.map((value: string) => encodeURI(value.replace(/\*|"|'|~|!|\?|\[|\]|\(|\)|\{|\}/g, '')));
  return parts.join(' AND ');
}

const buildSolrParams = (filters: Filter[], originalDatas: OriginalDatas) => {

  let params: Param[] = []
  filters.forEach((filter) => {

    switch (filter.id) {
      case "page":
        params.push({name: 'page', value:filter.values})
        break;
      case "sort":
        // case APP.ORDER.NAME.NAME:
        // case APP.ORDER.DURATION.NAME:
        // case APP.ORDER.DATE.NAME:
        let valueSort = filter.values;
        valueSort = typeof valueSort ==="string" ? [valueSort]: valueSort;
        const sortParam = {
          name: 'sort',
          value: (Array.isArray(filter.values) || typeof filter.values ==="string"  )?valueSort[0]:filter.values.field + ' ' + filter.values.direction,
        }
        params.push(sortParam)
        break;
      case APP.FILTER.SHORTAGE.FIELD:
        params.push({name: 'fq', value: filter.id+":"+filter.values[0]})
        break;
      case APP.FILTER.SEARCH.FIELD:
        const searchField = [
          'tcphoneticm_X3b_fr_field_field_formation_advantage',
          'tm_X3b_fr_field_field_formation_advantage_1',
          'tcphoneticm_X3b_fr_field_formation_course',
          'tm_X3b_fr_field_formation_course_1',
          'tcphoneticm_X3b_fr_field_formation_faculty',
          'tm_X3b_fr_field_formation_faculty_1',
          'tcphoneticm_X3b_fr_field_formation_job_finality',
          'tm_X3b_fr_field_formation_job_finality_1',
          'tcphoneticm_X3b_fr_field_formation_opportunity',
          'tm_X3b_fr_field_formation_opportunity_1',
          'tcphoneticm_X3b_fr_field_formation_opportunity_2',
          'tm_X3b_fr_field_formation_opportunity_2_1',
          'tm_X3b_fr_field__formation_prerequisite_1',
          'tcphoneticm_X3b_fr_field__formation_prerequisite',
          'tcphoneticm_X3b_fr_body',
          'tm_X3b_fr_body_1',
          'tcphoneticm_X3b_fr_product_body',
          'tm_X3b_fr_product_body_1',
        ];

        const boostedFields:TypeFormationMap = {
          'ss_product_title': 100,
          'tcphoneticm_X3b_fr_title': 80,
          'tcedgem_X3b_fr_title_4': 80,
          'ss_summary': 60,
          'tcphoneticm_X3b_fr_summary_3': 50,
          'tcedgem_X3b_fr_summary_2': 50,
          'ss_field_summary': 60,
          'tcphoneticm_X3b_fr_field_summary_3': 50,
          'tcedgem_X3b_fr_field_summary_2': 50,
        };

        const qQuery = () => {
          let query = '';

          // Process search fields.
          searchField.map((field, key) => {
            const asterisk = field.startsWith('tcphoneticm')?'':'*';
            const or = key !== searchField.length ? ' OR ' : '';
            query += ' ' + field + ' :( ' + sanitizeSolrInput(filter.values) + asterisk + ' )^20' + or;
          });

          // Process boosted fields.
          Object.keys(boostedFields).forEach((field) => {
            const asterisk = field.startsWith('tcphoneticm')?'':'*';
            query += ' ' + field + ' :( ' + sanitizeSolrInput(filter.values) + asterisk + ' )^' + boostedFields[field] + ' OR ';
          });

          // Remove trailing ' OR ' from the query.
          if (query.endsWith(' OR ')) {
            query = query.slice(0, -4);
          }

          return query;
        };
        const searchValue = qQuery();
        params.push({name: 'q', value: searchValue})
        break;
      case APP.FILTER.STARTDATE.FIELD:
        let startdateQuery;

        if (filter.values.length === 2){
          startdateQuery = "["+filter.values[0] + "T12:00:00Z TO " + filter.values[1] + "T12:00:00Z]"
        }else if (filter.values.length === 1){
          startdateQuery = "["+filter.values[0] + "T12:00:00Z TO *]"
        }
        params.push({
          name: 'fq',
          value: filter.id + ':' + startdateQuery
        })
        break;
      case APP.FILTER.DOMAINS.FIELD:
        let domainsValues: number[] = [];
        originalDatas.domains.map((domain) =>{
          if (filter.values.includes(domain.attributes.slug)) {
            domainsValues.push(domain.attributes.drupal_internal__tid)
          }
        })
        const domainValue = filter.id + ":(" + domainsValues.join(" OR ") + ")";
        params.push({name: 'fq', value: domainValue})
        break;
      case APP.FILTER.PLACES.FIELD:
        let placeValues: number[] = [];
        originalDatas.places.map((place) => {
            if (filter.values.includes(place.slug)) {
              placeValues.push(place.id)
            }
          }
        )
        if (placeValues.length > 0) {
          const placeIds = placeValues.join(" OR ");
          const placeValue = `(sm_product_centers:(${placeIds}) OR sm_variation_centers:(${placeIds}))`;
          params.push({name: 'fq', value: placeValue})
        }
        break
      case APP.FILTER.PRICERANGE.FIELD:
        const placesValue = filter.id + ":[" + filter.values.join(" TO ") + "]";
        params.push({name: 'fq', value: placesValue})
        break
      case APP.FILTER.TYPE_FORMATION.FIELD:
        // @todo correct type to remove @ts-ignore in this case
        if (filter.values.length > 0) {
          const convertedObject:TypeFormationMap = originalDatas.typeFormation.reduce((result, item) => {
            // @ts-ignore
            result[item.attributes.slug] = item.attributes.drupal_internal__tid;
            return result;
          }, {});
          let typeformationParam: any[] = [];
          filter.values.forEach((value: string | number) => {
            if(typeof value === "string"){
              typeformationParam.push(convertedObject[value]);
            }else{
              typeformationParam.push(value);
            }
          })
          params.push({
            name: 'fq',
            // @ts-ignore
            value: '{!tag=mainFilter}' + filter.id + ':(' + typeformationParam.join(' OR ') + ')'
          });
        }
        break
      case APP.FILTER.PUBLIC.FIELD:
        if (filter.values.length > 0) {
          params.push({
            name: 'fq',
            value: '{!tag=mainFilter}' + filter.id + ':(' + filter.values.join(' OR ') + ')'
          });
        }
        break;
      default :
        const value = filter.id + ":(" + filter.values.join(" OR ") + ")";
        params.push({name: 'fq', value: value})
        break;
    }

  })

  // params.push({
  //   name: 'fq',
  //   value: 'bm_variations_status:true',
  // });

  return params
}

export default buildSolrParams;
